import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { applyPageMeta, PAGE_SEO_CONFIG } from "../lib/seoMeta";

export default function NotFound() {
  useEffect(() => {
    applyPageMeta(PAGE_SEO_CONFIG.notFound);
  }, []);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-16 bg-white text-neutral-900">
      <div className="relative mb-6">
        <div className="text-9xl font-extrabold text-neutral-100 select-none">404</div>
        <div className="absolute inset-0 flex items-center justify-center">
          <i className="fa-solid fa-triangle-exclamation text-5xl text-yellow-500 animate-bounce" />
        </div>
      </div>
      <h1 className="text-3xl font-extrabold tracking-tight text-neutral-900 sm:text-4xl mb-4">
        Siden blev ikke fundet
      </h1>
      <p className="text-neutral-600 max-w-md mb-8 leading-relaxed">
        Beklager, men den side du leder efter findes ikke længere, eller er blevet flyttet. Brug menuen eller knappen nedenfor til at komme tilbage.
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        <Link
          to="/"
          className="bg-yellow-500 hover:bg-yellow-600 text-neutral-950 font-bold px-6 py-3 rounded-xl shadow-md transition-all duration-200 cursor-pointer"
        >
          Gå til forsiden
        </Link>
        <Link
          to="/kontakt"
          className="bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-bold px-6 py-3 rounded-xl transition-all duration-200"
        >
          Kontakt os
        </Link>
      </div>
    </div>
  );
}
